/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { FC, CSSProperties } from "react";
import { All } from "./dropEffects";
import { DraggableParams } from "../../types/components/dragAndDrop";

const draggingStyle: CSSProperties = {
  opacity: 0.25,
};

const Draggable: FC<DraggableParams> = (props: DraggableParams) => {
  const {
    children,
    dragImage,
    disableDrag = false,
    className = "",
    onDragging,
    onDragged,
    onClick,
  } = props;

  const [isDragging, setIsDragging] = React.useState(false);
  const image = React.useRef<HTMLImageElement>(null);
  const draggable = React.useRef<HTMLDivElement>(null);
  const isAllowDrag = !disableDrag;

  React.useEffect(() => {
    // @ts-ignore
    image.current = null;
    if (props.dragImage) {
      // eslint-disable-next-line no-undef
      // @ts-ignore
      image.current = new Image();
      image.current.src = props.dragImage;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dragImage]);

  const startDrag = (ev: React.DragEvent<HTMLDivElement>) => {
    const { dataItem, dropEffect = All } = props;
    if (isAllowDrag && draggable.current === ev.target) {
      // ignore parent drag
      setIsDragging(true);
      // @ts-ignore
      ev.dataTransfer.setData("drag-item", dataItem);
      // @ts-ignore
      ev.dataTransfer.effectAllowed = dropEffect;
      if (image.current) {
        ev.dataTransfer.setDragImage(image.current, 0, 0);
      }
    }
    if (onDragging) onDragging();
  };

  const dragEnd = () => {
    setIsDragging(false);
    if (onDragged) onDragged();
  };

  return (
    <div
      ref={draggable}
      onClick={onClick}
      className={className || ""}
      style={isDragging ? draggingStyle : {}}
      draggable={isAllowDrag}
      onDragStart={startDrag}
      onDragEnd={dragEnd}
    >
      {children}
    </div>
  );
};

export default Draggable;
